<mw-core-toolbar
  [logo]="service.companyLogoUrl"
  [title]="title | translate"
  [showToggler]="showToggler"
  [showCompactLogo]="showCompactLogo"
  [showFullscreenButton]="showFullScreenButton"
  [clickableTitle]="clickableTitle"
  (titleClick)="onTitleClick()"
  (toggle)="onToggleSidebar()"
>
  <button
    #btnNews
    mat-icon-button
    [class.mw-active]="newsFeedSidebarOpened"
    (click)="onNewsFeedClick()"
    *ngIf="showNewsButton"
  >
    <mat-icon>campaign</mat-icon>
  </button>

  <button
    #btnModules
    mat-icon-button
    (click)="onModulesButtonClick()"
    [class.mw-active]="appModuleSidebarOpened"
    *ngIf="showModuleButton"
  >
    <mat-icon>apps</mat-icon>
  </button>

  <button
    #btnProfile
    mat-icon-button
    [class.mw-active]="profileMenuSidebarOpened"
    (click)="onProfileButtonClick()"
  >
    <mat-icon>person_outline</mat-icon>
  </button>
</mw-core-toolbar>
<mw-notification-banner
  [alertId]="'generalAlert'"
  [isDisplayed]="false"
></mw-notification-banner>
